import { FocusTrap, ScrollLock, Swipeable, SwipeDirection } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { ComponentProps } from '../../ReactComponents/ComponentProps.csharp';
import { NavigationLinks } from './NavigationLinks/NavigationLinks';
import { NavigationViewModel } from './NavigationViewModel.csharp';
import { NavList } from './NavList/NavList';

interface NavigationProps extends ComponentProps<NavigationViewModel> {
    readonly isVisible: boolean;
    readonly onClose: () => void;
}

interface NavigationState {
    isSubNavigationOpen: boolean;
}

export class Navigation extends React.Component<NavigationProps, NavigationState> {
    constructor(props: NavigationProps) {
        super(props);

        this.state = {
            isSubNavigationOpen: false
        };
    }

    render() {
        const {
            props: { model, isVisible, onClose },
            state: { isSubNavigationOpen }
        } = this;

        return (
            <>
                <ScrollLock isLocked={isVisible} />
                <FocusTrap enabled={isVisible} applyActiveElement>
                    <Swipeable onSwipe={this.handleSwipe}>
                        <nav className={classNames('Navigation', isVisible && 'Navigation--Visible', isSubNavigationOpen && 'Navigation--WithSubNavigation')}>
                            <div className="Navigation__Content" onClick={onClose}>
                                <div className="Navigation__ContentOuter">
                                    <div className="Navigation__ContentInner" onClick={(e) => e.stopPropagation()}>
                                        <button className="Navigation__CloseButton" onClick={onClose} />

                                        {(model.firstSectionLinks || model.secondSectionLinks) && (
                                            <NavigationLinks firstSectionLinks={model.firstSectionLinks} secondSectionLinks={model.secondSectionLinks} />
                                        )}

                                        <div className="Navigation__CategoriesWrapper">
                                            <span className="Navigation__Title">{getTranslation(keys['header.products'])}</span>

                                            <NavList
                                                items={model.categories}
                                                isParentVisible={isVisible}
                                                onClickOutside={onClose}
                                                isFirstLevel
                                                setIsSubNavigationOpen={this.setIsSubNavigationOpen}
                                                additionalItemsName={model.thirdSection?.sectionName}
                                                additionalItems={model.thirdSection?.sectionLinks}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </Swipeable>
                </FocusTrap>
            </>
        );
    }

    private handleSwipe = (swipeDirection: SwipeDirection) => {
        if (swipeDirection === SwipeDirection.Left && this.props.isVisible) {
            this.props.onClose();
        }
    };

    private setIsSubNavigationOpen = (value: boolean) => {
        this.setState({ isSubNavigationOpen: value });
    };
}
